var _dec, _dec2, _dec3, _class;

import { Injectable } from "../inject/index.js";
import { NotificationService } from "./notification-service.js";
import { AbstractLogger, LogLevel } from "./index.js";
export let NotificationLogger = (_dec = Injectable({
  lifetime: 'scoped'
}), _dec2 = Reflect.metadata("design:type", Function), _dec3 = Reflect.metadata("design:paramtypes", [typeof NotificationService === "undefined" ? Object : NotificationService]), _dec(_class = _dec2(_class = _dec3(_class = class NotificationLogger extends AbstractLogger {
  useLogLevels(loglevels) {
    this.logLevels = loglevels;
  }

  async addEntry(entry) {
    if (this.logLevels.includes(LogLevel[entry.level])) {
      this.notificationService.add(entry);
    }
  }

  constructor(notificationService) {
    super();
    this.notificationService = notificationService;
    this.logLevels = ['Information', 'Warning', 'Error', 'Fatal'];
  }

}) || _class) || _class) || _class);
//# sourceMappingURL=notification-logger.js.map